package com.upcominds.expedite.features.signUp

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.upcominds.expedite.data.challenges.ChallengesRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update

data class SignUpUiState(
    val name: String = "",
    val email: String = "",
    val password: String = "",
    val isSignUpEnabled: Boolean = false,
    val loading: Boolean = false,
    val error: String? = null,
)


class SignUpViewModel(
    private val challengesRepository: ChallengesRepository
): ViewModel() {

    private val _uiState = MutableStateFlow(SignUpUiState())
    val uiState: StateFlow<SignUpUiState> = _uiState.asStateFlow()

    init {
        combine(
            _uiState.map { it.name },
            _uiState.map { it.email },
            _uiState.map { it.password }
        ) { name, email, password ->
            name.isNotBlank() && email.isNotBlank() && password.isNotBlank()
        }.onEach { isEnabled ->
            _uiState.update { it.copy(isSignUpEnabled = isEnabled) }
        }.launchIn(viewModelScope)
    }

    fun updateName(name: String) {
        _uiState.update { it.copy(name = name) }
    }

    fun updateEmail(email: String) {
        _uiState.update { it.copy(email = email) }
    }

    fun updatePassword(password: String) {
        _uiState.update { it.copy(password = password) }
    }

    fun signUp() {

    }
}